// extracted by mini-css-extract-plugin
export default {"qrcode":"qrcode--psnuRq5Ajk"};